/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SyncTrackFeatureItemDtoFromJSON, SyncTrackFeatureItemDtoToJSON, } from './SyncTrackFeatureItemDto';
/**
 * Check if a given object implements the SyncTrackFeaturesRequestDto interface.
 */
export function instanceOfSyncTrackFeaturesRequestDto(value) {
    if (!('features' in value) || value['features'] === undefined)
        return false;
    return true;
}
export function SyncTrackFeaturesRequestDtoFromJSON(json) {
    return SyncTrackFeaturesRequestDtoFromJSONTyped(json, false);
}
export function SyncTrackFeaturesRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'features': (json['features'].map(SyncTrackFeatureItemDtoFromJSON)),
    };
}
export function SyncTrackFeaturesRequestDtoToJSON(json) {
    return SyncTrackFeaturesRequestDtoToJSONTyped(json, false);
}
export function SyncTrackFeaturesRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'features': (value['features'].map(SyncTrackFeatureItemDtoToJSON)),
    };
}
